//   ________________________________________________________
// SNIPPET FOR USAGE IN VSCODE
//   ________________________________________________________
//project.code-snippets
//   {

//     "my logger": {
//         "prefix": "logg",
//         "body": "logger.log()($1)"
//     },

// }

type Logger = {
  log: () => Function
}

export const logger: Logger = {
  log: () => {
    if (isBrowser() && isDev()) {
      return window.console.log
    } else {
      return () => {}
    }
  },
}

export const isDev = (): boolean => {
  return process.env.NODE_ENV === 'development'
}

export const isBrowser = () => typeof window !== 'undefined'
